import React from 'react';
import { Map, TileLayer, GeoJSON } from 'react-leaflet';
import L from 'leaflet';

import 'leaflet/dist/leaflet.css';
import styles from './CustomMap.module.scss';

const mbUser = 'makinacorpus';
const mbStyleID = 'cjpdvdqdj0b7a2slajmjqy3py';
const mbAccessToken = 'pk.eyJ1IjoibWFraW5hY29ycHVzIiwiYSI6ImNqY3E4ZTNwcTFta3ozMm80d2xzY29wM2MifQ.Nwl_FHrWAIQ46s_lY0KNiQ';
const mbTileLayer = `https://api.mapbox.com/styles/v1/${mbUser}/${mbStyleID}/tiles/256/{z}/{x}/{y}?access_token=${mbAccessToken}`;

const CustomMap = ({ geojson, bounds, color }) => {
  if (!geojson) {
    return null;
  }

  return (
    <Map
      bounds={bounds}
      style={{ minHeight: 400 }}
      attributionControl={false}
      ref={() => window.dispatchEvent(new Event('resize'))}
      className={styles.map}
    >
      <TileLayer url={mbTileLayer} />

      <GeoJSON
        data={geojson}
        interactive={false}
        style={({ geometry }) => ({
          weight: geometry.type === 'Point' ? 4 : 1,
          color,
        })}
        pointToLayer={(feature, latLng) => L.circleMarker(latLng, { radius: 2 })}
        onEachFeature={({ properties }, layer) => layer.bindPopup(`<strong>${properties.siret}</strong>`)}
      />

    </Map>
  );
};

export default CustomMap;
